// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2YKjB","actions":"styles_actions__3NHeS","error":"styles_error__2ChEv","message":"styles_message__Tz7BT"};